import * as React from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import { NewsItem_NewsItemEdgeFragment } from 'generated/graphql'
import getChannelOgData from '@app.feature/channel/module/getChannelOgData'
import useIsMobile from '@app.modules/hooks/useIsMobile'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import { getWebviewHref } from '@app.modules/util'
import { mobileBreakPoint } from 'app.styled/media'
import NewsItemContent from '../../component/NewsItemContent'
import NewsCardFooter from '../../component/NewsItemFooter/NewsItemFooter'
import NewsHeader from '../../component/NewsItemHeader/NewsItemHeader'

type Tprops = {
  data: Omit<NewsItem_NewsItemEdgeFragment, '__typename' | 'cursor'>
  onClose?: () => void
  className?: string
}

const ScreenNewsItemModalMobile: React.FC<Tprops> = ({
  data,
  onClose,
  className,
}) => {
  const router = useRouter()
  const isMobile = useIsMobile()
  const isWebview = useIsWebview()

  const handleCommentBtnClick = () => {
    if (isMobile) {
      if (
        router.pathname ===
        getWebviewHref('/channel/[channel-url]/[news-id]', isWebview)
      ) {
        onClose && onClose()
      } else
        router.push(
          getWebviewHref(
            `/channel/${data.header?.channel?.url}/${data.header?.id}`,
            isWebview,
          ),
        )
    }
  }
  const ogData = getChannelOgData({ data })

  return (
    <StyledWrapper className={className}>
      <div className="top">
        <div className="close-btn" onClick={onClose}>
          <Close />
        </div>
        <NewsHeader data={data.header!} type="modal" />
        <NewsItemContent type="modal" data={data.content!} />
      </div>
      <NewsCardFooter
        type="modal"
        data={data.footer!}
        onCommentBtnClick={handleCommentBtnClick}
        ogData={ogData}
      />
    </StyledWrapper>
  )
}

export default ScreenNewsItemModalMobile

const StyledWrapper = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #333;
  flex-direction: column;
  justify-content: space-between;
  .close-btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    color: white;
    cursor: pointer;
    padding: 20px 20px 0;
    svg {
      fill: #fff;
      width: 16px;
      height: 16px;
    }
  }
  .top {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
  }

  ${mobileBreakPoint} {
    display: flex;
  }
`
